import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Tooltip from '../Tooltip';
import { COLOR_LABELS } from '../../helpers/colorsHelper';
import { selectColorOptions } from '../../store/selectors/colorLabels';
import makeTooltipText from './helpers/tooltipColorText';

function Color({
  color = null, highlight, highlightAnimationReset, colorAt = null, colorBy = null,
}) {
  const colors = useSelector(selectColorOptions);
  const selectedColor = useMemo(
    () => colors.find((colorItem) => colorItem.value === color)
      || colors.find((colorItem) => colorItem.value === COLOR_LABELS.noColor),
    [color, colors],
  );

  const tooltipText = useMemo(
    () => makeTooltipText(selectedColor.title || '', colorAt, colorBy),
    [selectedColor.title, colorAt, colorBy],
  );

  return (
    <Tooltip content={tooltipText} placement="top">
      <div
        className={cn('catalogItem__color', {
          showColorCatalogItem: selectedColor.value !== COLOR_LABELS.noColor,
          highlightBlink: highlight,
        })}
        style={{ background: selectedColor.background }}
        onAnimationEnd={() => highlightAnimationReset('color')}
      />
    </Tooltip>
  );
}

Color.propTypes = {
  color: PropTypes.string,
  highlight: PropTypes.bool.isRequired,
  highlightAnimationReset: PropTypes.func.isRequired,
  colorAt: PropTypes.string,
  colorBy: PropTypes.shape({
    _id: PropTypes.string,
    displayName: PropTypes.string,
    email: PropTypes.string,
  }),
};

export default memo(Color);
